module.exports = "fragment LabeledPriceFragment on LabeledPrice {\n  __typename\n  label\n  asString\n  currency\n  amount\n}\n"